import { GuideItem, GuideContent } from '../guides';

export const guide3Item: GuideItem = {
  id: '3',
  title: 'Mild But Mighty: Korean Dishes Without the Spice',
  titleEn: 'Mild But Mighty: Korean Dishes Without the Spice',
  titleJa: '辛くないけど大満足！やさしい韓国料理5選',
  titleZhCn: '温和也有料：5道不辣却美味的韩国料理',
  titleZhTw: '不辣也精彩：5道溫和又美味的韓國料理',
  image: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8.png',
  imageEn: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8.png',
  imageJa: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8-JP.png',
  imageZhCn: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8-CN.png',
  imageZhTw: 'https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8-TW.png',
  description: 'For travelers who crave comfort, not fire — here are 5 Korean meals full of flavor, minus the heat.',
  descriptionEn: 'For travelers who crave comfort, not fire — here are 5 Korean meals full of flavor, minus the heat.',
  descriptionJa: '刺激よりも“ほっとする味”を求めるあなたに。\n韓国の旨みをそのままに、辛くない人気メニューをご紹介します。',
  descriptionZhCn: '不喜欢辣？没关系！\n这5道菜没有火辣的刺激，却充满韩式风味和温暖的满足感。',
  descriptionZhTw: '想吃得舒服又不想被辣翻？\n這5道菜無辣但風味十足，是旅人最安心的選擇。'
};

export const guide3Content: GuideContent = {
  title: 'Mild But Mighty: Korean Dishes Without the Spice',
  titleEn: 'Mild But Mighty: Korean Dishes Without the Spice',
  titleJa: '辛くないけど大満足！やさしい韓国料理5選',
  titleZhCn: '温和也有料：5道不辣却美味的韩国料理',
  titleZhTw: '特許經營總部註冊指南',
  subtitle: 'For travelers who crave comfort, not fire — here are 5 Korean meals full of flavor, minus the heat.',
  subtitleEn: 'For travelers who crave comfort, not fire — here are 5 Korean meals full of flavor, minus the heat.',
  subtitleJa: '刺激よりも“ほっとする味”を求めるあなたに。\n韓国の旨みをそのままに、辛くない人気メニューをご紹介します。',
  subtitleZhCn: '不喜欢辣？没关系！\n这5道菜没有火辣的刺激，却充满韩式风味和温暖的满足感。',
  subtitleZhTw: '想吃得舒服又不想被辣翻？\n這5道菜無辣但風味十足，是旅人最安心的選擇。',
  markdownContent: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8.png)  
  ## 🥢 Mild Korean Food, Big Flavor

*Not all Korean food is spicy — these 5 dishes prove it.*

Korean cuisine is known for its bold spices and heat, but not everything on the menu sets your mouth on fire.

If you prefer savory, mild, and comforting dishes, here are 5 popular Korean meals that pack big flavor — no spice required.

And the best part? You can skip the lines and enjoy all of them through delivery.

## 1. Korean Toast

https://youtu.be/aykR42VYgh4

# (버튼 1)

**Savory, sweet, and totally addictive.**

You might’ve seen long lines at Myeongdong street food stalls — but now you can get *even better* Korean-style toast delivered right to your door.

These sandwiches are made with thick buttery bread, scrambled eggs, shredded cabbage, ham, and a sweet sauce that ties it all together.

It’s warm, filling, and perfectly balanced — great for breakfast or a light lunch.

> 🥪 No waiting in line. Just comfort food in sandwich form.
> 

---

## 2. Gimbap (Korean Rice Rolls)

https://youtu.be/bydNjRr1sWs

# (버튼 2)

**Mild, neat, and easy to love.**

Think sushi, but fully cooked. Gimbap is a rolled seaweed wrap filled with rice, egg, veggies, and sometimes tuna or beef.

It’s portable, clean-tasting, and endlessly customizable.

Perfect for a light meal or a quick snack.

> 👍 Great choice if you're new to Korean food.
> 

---

## 3. Galbitang (Beef Short Rib Soup)

https://youtu.be/T-yk_W67dXs

# (버튼 3)

**Comfort in a bowl.**

This clear soup made from slow-simmered beef short ribs is deeply savory and nourishing.

Tender meat, soft radish, and glass noodles come together in a light broth that warms you from the inside.

It’s traditional, satisfying, and gentle on the stomach.

> 🥣 Often served with rice — ideal for chilly days or when you want something cozy.
> 

---

## 4. Bulgogi (Marinated Beef BBQ)

https://www.youtube.com/watch?v=uGpABJ_GcTM

# (버튼 4)

**Sweet, savory, and familiar.**

Bulgogi is thin-sliced beef marinated in soy sauce, garlic, and sugar, then grilled or pan-fried until juicy and caramelized.

It has a sweet-salty profile that’s often compared to teriyaki, but with a Korean twist.

Great on its own or served with rice and vegetables.

> 🍚 One of Korea’s most beginner-friendly dishes.
> 

---

## 5. Samgyeopsal (Grilled Pork Belly)

https://youtu.be/eQ0mk3Q-VuU

# (버튼 5)

**Korean BBQ classic, no spice required.**

Thick slices of pork belly grilled to golden perfection, usually eaten wrapped in lettuce with garlic, rice, and a touch of sauce.

It’s rich, meaty, and full of texture — a must-try for any meat lover.

No marinade needed — just good meat and good grilling.

> 🔥 Most places now offer samgyeopsal BBQ sets delivered, ready to eat at home.
>
  `,
  markdownContentEn: `
![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8.png)  

## 🥢 Mild Korean Food, Big Flavor

*Not all Korean food is spicy — these 5 dishes prove it.*

Korean cuisine is known for its bold spices and heat, but not everything on the menu sets your mouth on fire.

If you prefer savory, mild, and comforting dishes, here are 5 popular Korean meals that pack big flavor — no spice required.

And the best part? You can skip the lines and enjoy all of them through delivery.

## 1. Korean Toast

https://youtu.be/aykR42VYgh4

# (버튼 1)

**Savory, sweet, and totally addictive.**

You might’ve seen long lines at Myeongdong street food stalls — but now you can get *even better* Korean-style toast delivered right to your door.

These sandwiches are made with thick buttery bread, scrambled eggs, shredded cabbage, ham, and a sweet sauce that ties it all together.

It’s warm, filling, and perfectly balanced — great for breakfast or a light lunch.

> 🥪 No waiting in line. Just comfort food in sandwich form.
> 

---

## 2. Gimbap (Korean Rice Rolls)

https://youtu.be/bydNjRr1sWs

# (버튼 2)

**Mild, neat, and easy to love.**

Think sushi, but fully cooked. Gimbap is a rolled seaweed wrap filled with rice, egg, veggies, and sometimes tuna or beef.

It’s portable, clean-tasting, and endlessly customizable.

Perfect for a light meal or a quick snack.

> 👍 Great choice if you're new to Korean food.
> 

---

## 3. Galbitang (Beef Short Rib Soup)

https://youtu.be/T-yk_W67dXs

# (버튼 3)

**Comfort in a bowl.**

This clear soup made from slow-simmered beef short ribs is deeply savory and nourishing.

Tender meat, soft radish, and glass noodles come together in a light broth that warms you from the inside.

It’s traditional, satisfying, and gentle on the stomach.

> 🥣 Often served with rice — ideal for chilly days or when you want something cozy.
> 

---

## 4. Bulgogi (Marinated Beef BBQ)

https://www.youtube.com/watch?v=uGpABJ_GcTM

# (버튼 4)

**Sweet, savory, and familiar.**

Bulgogi is thin-sliced beef marinated in soy sauce, garlic, and sugar, then grilled or pan-fried until juicy and caramelized.

It has a sweet-salty profile that’s often compared to teriyaki, but with a Korean twist.

Great on its own or served with rice and vegetables.

> 🍚 One of Korea’s most beginner-friendly dishes.
> 

---

## 5. Samgyeopsal (Grilled Pork Belly)

https://youtu.be/eQ0mk3Q-VuU

# (버튼 5)

**Korean BBQ classic, no spice required.**

Thick slices of pork belly grilled to golden perfection, usually eaten wrapped in lettuce with garlic, rice, and a touch of sauce.

It’s rich, meaty, and full of texture — a must-try for any meat lover.

No marinade needed — just good meat and good grilling.

> 🔥 Most places now offer samgyeopsal BBQ sets delivered, ready to eat at home.
>  
  `,
  markdownContentJa: `

  ![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8-JP.png)  

## 🥢 辛くないのに旨い！やさしい味の韓国料理

*「韓国料理＝辛い」だけじゃない！この5品がそれを証明します。*

韓国料理といえば辛さや刺激的な味付けをイメージする人も多いですが、

すべての料理が辛いわけではありません。

塩気や旨味をしっかり感じられる、**やさしくてホッとする味**をお求めの方へ。

**辛くなくても大満足**できる、人気の韓国料理5選をご紹介します。

しかもすべて**デリバリーで並ばずに楽しめる**のも嬉しいポイント！

## 1. 韓国風トースト

https://youtu.be/aykR42VYgh4

# (버튼 1)

**しょっぱい×甘いの絶妙バランス！ついついハマる味。**

明洞の屋台に行列ができる人気グルメとして知られる韓国トースト。

でも今なら、**もっと美味しい韓国風トーストをデリバリーで気軽に楽しめます！**

バターで焼いた厚切りパンに、スクランブルエッグ、千切りキャベツ、ハム、

そして甘いソースが絶妙に絡んだサンドイッチ。

朝ごはんにも軽めのランチにもぴったりの、温かくて食べ応えのある一品です。

> 🥪 並ばずに、ホテルでホッとできるサンドイッチを。
> 

---

## 2. キンパ（韓国のり巻き）

https://youtu.be/bydNjRr1sWs

# (버튼 2)

**やさしい味わい＆食べやすさが魅力。**

見た目はお寿司のようですが、**具材はすべて火を通してある**のがキンパの特徴。

ご飯、卵、野菜、ツナや牛肉などを海苔で巻いた、

**あっさりしていて持ち運びやすい韓国定番メニュー**です。

軽食にも、小腹が空いたときにもぴったり。

> 👍 韓国料理ビギナーにおすすめ！
> 

---

## 3. カルビタン（牛カルビスープ）

https://youtu.be/T-yk_W67dXs

# (버튼 3)

**一杯に詰まったやさしい癒し。**

牛カルビをじっくり煮込んで作る**澄んだスープ**で、

コク深く、身体の芯から温まるような味わいです。

やわらかいお肉、大根、春雨があっさりしたスープとよく合い、

**優しくもしっかり満足感のある伝統料理**です。

> 🥣 ごはんと一緒に食べるのが定番。寒い日や、体を休めたいときにぴったり！
> 

---

## 4. プルコギ（牛肉の甘辛焼き）

https://www.youtube.com/watch?v=uGpABJ_GcTM

# (버튼 4)

**甘くてしょっぱい、親しみやすい味わい。**

プルコギは、薄切りの牛肉を**醤油・にんにく・砂糖で漬け込んだ**韓国の定番焼肉メニュー。

鉄板やフライパンで焼くことで、ジューシーでほんのりキャラメリゼされた香ばしい仕上がりに。

甘じょっぱい味は**照り焼きに似ている**とも言われ、初めての方でも食べやすい味です。

ごはんや野菜と一緒に食べるのもおすすめ！

> 🍚 韓国料理初心者にも人気の安心メニュー。
> 

---

## 5. サムギョプサル（豚バラ焼き）

https://youtu.be/eQ0mk3Q-VuU

# (버튼 5)

**辛くない、韓国焼肉の定番。**

厚切りの豚バラ肉を**香ばしく焼き上げ**、

レタスにご飯やにんにく、タレと一緒に包んで食べるスタイルが定番。

しっかりとしたお肉の旨みと食感が味わえる、

**お肉好きにはたまらない一品**です。

下味をつけず、**素材そのものと焼き加減で勝負する**のが魅力。

> 🔥 最近では、サムギョプサルのBBQセットもデリバリー対応！ホテルでも楽しめます。
>
  
`,
  markdownContentZhCn: `

![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8-CN.png)  
  
## 🥢 温和不等于无味：5道不辣也好吃的韩餐推荐

*不是所有韩餐都辣，这5道菜就是最佳证明！*

韩国料理以重口和辣味闻名，但其实菜单上也有很多**不辣却美味**的选项。

如果你喜欢咸香、温和、令人安心的食物，

这5道**不辣却风味十足**的韩国人气料理值得一试。

最棒的是——**不用排队，在家就能轻松外卖享受**！

## 1. 韩式吐司

https://youtu.be/aykR42VYgh4

# (버튼 1)

**咸甜交错，让人一吃就上瘾。**

你可能在明洞看过小吃摊前大排长龙，

但现在你可以**直接点外卖，享受更美味的韩式吐司**！

这款三明治采用厚片奶油吐司夹入炒蛋、卷心菜丝、火腿，

并淋上特制的甜味酱料，风味层次分明，口感扎实。

温热又有饱足感，无论当早餐或轻食午餐都很适合。

> 🥪 不用排队，在饭店也能吃到让人安心的韩式三明治。
> 

---

## 2. 紫菜包饭（Gimbap）

https://youtu.be/bydNjRr1sWs

# (버튼 2)

**温和、整洁、人人都能喜欢的口味。**

看起来像寿司，但**所有食材都是熟的**。

紫菜包饭通常包着米饭、鸡蛋、蔬菜，有时还有金枪鱼或牛肉。

味道清爽、方便携带，而且可以根据喜好变化多端。

很适合做为轻食或小吃。

> 👍 如果你是韩餐新手，这是一个不错的起点！
> 

---

## 3. 牛骨汤（Galbitang）

https://youtu.be/T-yk_W67dXs

# (버튼 3)

**一碗满满的温暖与滋养。**

这是一道用牛小排慢炖而成的**清汤料理**，风味浓郁、营养丰富。

汤中配有软嫩的牛肉、白萝卜和粉丝，

在清淡的汤底中融合出温柔又满足的味道。

是一道传统又舒适的韩式美食，**对胃也很友好**。

> 🥣 通常搭配米饭享用，特别适合天气凉时或想吃点温暖食物的时候。
> 

---

## 4. 韩式烤牛肉（Bulgogi）

https://www.youtube.com/watch?v=uGpABJ_GcTM

# (버튼 4)

**甜咸适中，让人倍感熟悉。**

韩式烤牛肉是将牛肉切成薄片，

用**酱油、大蒜和糖腌制后**炙烤或煎炒而成，入口多汁、微微焦糖化。

它的风味常被比作**日式照烧**，但多了一份韩式独有的香气与甜味。

可以单吃，也可以搭配米饭和蔬菜。

> 🍚 是外国人初次尝试韩餐时的热门选择！
> 

---

## 5. 五花肉烧烤（Samgyeopsal）

https://youtu.be/eQ0mk3Q-VuU

# (버튼 5)

**无辣版的韩国烧烤经典。**

厚切五花肉烤至表皮金黄酥脆，

常搭配生菜、蒜片、米饭和酱料一起食用，风味浓郁、口感丰富。

这道菜不需腌制，**讲究的是肉质本身和火候**。

是肉食爱好者不可错过的经典韩式烧烤。

> 🔥 现在许多地方都能提供五花肉烧烤外卖套餐，在家也能轻松享受！
>  

  `,
  markdownContentZhTw: `

![대지 12.png](https://recipeee-api.s3.ap-northeast-2.amazonaws.com/delivereee/%E1%84%86%E1%85%A2%E1%86%B8%E1%84%8C%E1%85%B5%E1%84%8B%E1%85%A1%E1%86%AD%E1%84%8B%E1%85%B3%E1%86%AB%E1%84%92%E1%85%A1%E1%86%AB%E1%84%80%E1%85%AE%E1%86%A8%E1%84%8B%E1%85%B3%E1%86%B7%E1%84%89%E1%85%B5%E1%86%A8-TW.png)  

## 🥢 不辣也有味：5道溫和系韓式料理推薦

*不是所有韓國料理都會辣，這5道菜就是最佳證明！*

韓國料理常給人「重口味、很辣」的印象，

但其實也有許多**口感溫和卻風味十足**的選擇。

如果你偏好鹹香、柔和、讓人安心的味道，

這5道**不辣但美味滿分**的韓式人氣料理你一定要試試！

而且最棒的是——**不用排隊，外送就能享受道地韓國味！**

## 1. 韓式吐司

https://youtu.be/aykR42VYgh4

# (버튼 1)

**鹹中帶甜，讓人一口接一口的魔性美味。**

你或許在明洞路邊攤看過排隊人潮，

但現在你可以**不用出門，就能吃到更美味的韓式吐司**！

厚切奶油吐司夾入炒蛋、細切高麗菜、火腿，

加上甜甜的特製醬料，整體味道溫暖又平衡。

熱熱的、份量剛好，是早餐或輕食午餐的完美選擇。

> 🥪 免排隊，在飯店也能享受的療癒系三明治。
> 

---

## 2. 紫菜飯捲（Gimbap）

https://youtu.be/bydNjRr1sWs

# (버튼 2)

**溫和口感、乾淨俐落、人人都能接受的味道。**

看起來像壽司，但**內容物都是熟食**。

韓式紫菜飯捲通常包含米飯、雞蛋、蔬菜，有時加上鮪魚或牛肉，

吃起來清爽可口，方便攜帶，也能依照個人喜好變化餡料。

是輕食或解嘴饞的絕佳選擇。

> 👍 第一次嘗試韓式料理的朋友，非常推薦！
> 

---

## 3. 排骨湯（Galbitang）

https://youtu.be/T-yk_W67dXs

# (버튼 3)

**一碗溫柔又滋補的韓式湯品。**

這道清湯是用牛小排長時間燉煮而成，**湯頭清澈但充滿濃郁肉香**，讓人一口暖到心。

柔嫩的牛肉、白蘿蔔與粉絲，在淡雅的湯中完美融合，

**溫和又有飽足感，非常適合想吃點清淡卻不無聊的時候。**

> 🥣 通常會附白飯一起吃，適合天冷或想好好放鬆的時候。
> 

---

## 4. 韓式烤牛肉（Bulgogi）

https://www.youtube.com/watch?v=uGpABJ_GcTM

# (버튼 4)

**鹹中帶甜，親切又熟悉的味道。**

Bulgogi 是將牛肉切成薄片後，

用**醬油、大蒜與糖醃製**，再烤或煎至表面微焦、肉質多汁。

這道料理的味道常被拿來與**日式照燒**比較，

但帶有獨特的韓式風格，香甜又不膩。

可以單吃，也適合搭配白飯和蔬菜一起享用。

> 🍚 是最適合韓國料理入門者的經典推薦！
> 

---

## 5. 三層肉烤肉（Samgyeopsal）

https://youtu.be/eQ0mk3Q-VuU

# (버튼 5)

**無需辣味的韓式燒肉經典。**

厚切三層肉烤至金黃香酥，

通常搭配生菜、蒜頭、白飯和韓式醬料一起食用，口感豐富、滋味十足。

這道料理不需醃製，**吃的是食材本身的鮮味與炭烤的香氣**。

肉控絕對不能錯過的一道韓式名菜。

> 🔥 現在許多店家都提供三層肉BBQ外送套餐，在飯店也能輕鬆享用！
>  

  `,
  inlineButtons: [
    {
      id: "1",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Toast",
    },
    {
      id: "2",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Gimbap",
    },
    {
      id: "3",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Galbitang"
    },
    {
      id: "4",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Bulgogi",
      categoryId: "JUGm4biv",
    },
    {
      id: "5",
      text: "Craving this now? Order Here!",
      textEn: "Craving this now? Order Here!",
      textJa: "今すぐ食べたい？こちらで注文！",
      textZhCn: "现在就想吃？在这里订购！",
      textZhTw: "現在就想吃？在這裡訂購！",
      menuName: "Samgyeopsal",
    },
  ]
}; 